import { Validators } from "@angular/forms";

export const CustomValidators = {
    numeric: Validators.pattern(/^[0-9]+(\.?[0-9]+)?$/),
    email: Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
    password: Validators.pattern("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.* ).{8,16}$")
}